import Loading from 'bitmovin-web-ui/src/components/generic/loading';
import React from 'react';
import styled from 'styled-components';

import {pxToEm} from './globalStyles';

const StyledFullscreenDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: ${pxToEm(100)}em;
    height: ${pxToEm(100)}em;
  }
`;

const FullscreenLoader: React.FunctionComponent = () => (
  <StyledFullscreenDiv>
    <Loading />
  </StyledFullscreenDiv>
);

export default FullscreenLoader;
